import React, { Fragment } from 'react';

import ReactTooltip from 'react-tooltip';
import { Badge } from 'react-bootstrap';
import './PatientListTableFormatter.scss';
import MLDashboardWidget from './components/MLDashboardWidget';
import { FavouriteStar } from '../ProfileBar/components';

import checkmarkIcon from '../../../assets/img/checkmark.png';
import exclamationIcon from '../../../assets/img/exclamation.png';
import pinkBellIcon from '../../../assets/img/pinkBell.png';
import bellIcon from '../../../assets/img/bell.png';

let uKey = 0;

function notesFormatter(cell, row) {
  if (cell) {
    const tagShortNames = cell.tag_short_name.split('~');
    // deduplicate the tagShortNames
    const uniqueTagShortNames = [...new Set(tagShortNames)];
    const tagExpirationTime = cell.tag_expiration_time.split('~');
    const tagLimit = 2;
    const combinedTagsAndExpirations = uniqueTagShortNames
      .slice(tagLimit)
      .map((tag, i) => `${tag} (${tagExpirationTime[tagLimit + i]})`);
    // const expiration = `(${tagExpirationTime[i]})`
    return (
      <>
        {uniqueTagShortNames.slice(0, tagLimit).map((tagShortName, i) => (
          <Badge
            className="tagShortName"
            style={{ cursor: 'default' }}
            data-tip={`${uniqueTagShortNames[i]} `}
            key={i}
          >
            {tagShortName}
          </Badge>
        ))}
        {uniqueTagShortNames.length > tagLimit && (
          <Badge
            className="tagNumber"
            data-tip={combinedTagsAndExpirations.join(', ')}
            style={{ cursor: 'default' }}
          >
            +{uniqueTagShortNames.length - tagLimit}
          </Badge>
        )}
        <ReactTooltip />
      </>
    );
  }

  return null;
}
function namesFormatter(cell, row) {
  if ((cell, row)) {
    return (
      <>
        <p
          className="clickable"
          style={{ cursor: 'default', marginTop: '10%' }}
          data-tip={`
              ${row.dob} <br> 
              ${
                Array.isArray(row.client_no) && row.client_no.length > 0
                  ? row.client_no
                      .map((id) =>
                        id && id.client_no
                          ? `UR${id.client_no}`
                          : 'No valid client number',
                      )
                      .join('<br>')
                  : 'No valid client number'
              }

            `}
          data-html={true}
        >
          {cell}
        </p>
        <ReactTooltip />
      </>
    );
  }
}
function imageFormatter(cell, row, dataField = '') {
  if (cell) {
    let icon = cell.icon;

    if (icon == 'redArrowUp') {
      icon = 'redDots';
    } else if (icon == 'greenArrowDown') {
      icon = 'greenDots';
    }

    const tooltipRefKey = dataField
      ? `img-${icon}-${row.access_token}-${dataField}`
      : `img-${icon}-${row.access_token}`;

    return (
      <>
        <Fragment key={uKey++}>
          <div style={{ textAlign: 'center', paddingRight: '20px' }}>
            <img
              src={`img/${icon}.png`}
              alt=""
              className={icon}
              data-tip
              data-for={tooltipRefKey}
            ></img>
          </div>
          <ReactTooltip id={tooltipRefKey} html>
            {cell.description}
          </ReactTooltip>
        </Fragment>
      </>
    );
  }
}

function medsFormatter(cell, row) {
  if (cell)
    return (
      <Fragment key={uKey++}>
        {row.isNewMessage && (
          <img src={bellIcon} alt="Bell" className="bell"></img>
        )}
        <span>{cell}</span>
      </Fragment>
    );
}

function syncFormatter(sync, row) {
  if (sync && row.episodeClosures.length == 0)
    return (
      <div key={uKey++} className="centered-text">
        <img
          src={checkmarkIcon}
          alt="Checked"
          className="checkmark"
          style={{ opacity: '0.3' }}
        ></img>
      </div>
    );
  else if (!sync && row.episodeClosures.length > 0)
    return (
      <div key={uKey++} className="centered-text">
        <div key={uKey++} className="centered-text">
          <img
            src={exclamationIcon}
            className="exclamation"
            alt="Exclamation"
            data-tip
            data-for="syncTip"
          ></img>
          <ReactTooltip id="syncTip">
            Sync stopped - no <br />
            longer a patient
          </ReactTooltip>
        </div>
      </div>
    );
  else
    return (
      <div key={uKey++} className="centered-text">
        <div key={uKey++} className="centered-text">
          <img
            src={exclamationIcon}
            className="exclamation"
            alt="Exclamation"
          ></img>
        </div>
      </div>
    );
}

function syncHeaderFormatter(column) {
  return (
    <div className="centered-text" key={uKey++}>
      <span>{column.text}</span>
      <span
        className={'badge rounded-pill badgeInfo'}
        data-tip
        data-for="syncHeaderTip"
      >
        i
      </span>
      <ReactTooltip id="syncHeaderTip">
        <span>
          Synced with MHR in <br />
          last 7 days
        </span>
      </ReactTooltip>
    </div>
  );
}

function mhrHeaderFormatter(column, colIndex, components) {
  return (
    <div className="left-text" key={uKey++}>
      <span>{column.text}</span>
      <span
        className={'badge rounded-pill badgeInfo'}
        data-tip
        data-for="mhrHeaderTip"
      >
        i
      </span>
      <ReactTooltip id="mhrHeaderTip">
        <span>
          Latest
          <br />
          MHR data
        </span>
      </ReactTooltip>
    </div>
  );
}

function commHeaderFormatter(column, colIndex, components) {
  return (
    <div key={uKey++}>
      <span>{column.text}</span>
      <span
        className={'badge rounded-pill badgeInfo'}
        data-tip
        data-for="commHeaderTip"
      >
        i
      </span>
      <ReactTooltip id="commHeaderTip">
        <span>
          Latest
          <br />
          communication
        </span>
      </ReactTooltip>
    </div>
  );
}

function standardHeaderFormatter(column, colIndex, components) {
  return (
    <div className="col-3" key={uKey++}>
      {components.sortElement}
    </div>
  );
}

function insightsHeaderFormatter(column, colIndex, components) {
  return (
    <div className={'left-text p-1'} key={uKey++}>
      <div className="d-flex justify-content-between">
        <span className="text-left p-1">{column.text}</span>
        {components.sortElement}
      </div>
      <div className="row mt-3">
        <div className={'col-1'}></div>
        <div className={'col-4'}>High</div>
        <div className={'col-2'}></div>
        <div className={'col-4'}>Med</div>
      </div>
    </div>
  );
}

function assignFormatter(cell) {
  if (cell) {
    return (
      <div key={uKey++} className="right-text" style={{ width: '17px' }}>
        <img src={pinkBellIcon} style={{ width: '16px' }} alt=""></img>
      </div>
    );
  } else
    return (
      <div key={uKey++} className="right-text" style={{ width: '17px' }}>
        <p></p>
      </div>
    );
}

const mlWidgetFormatter = (cell) => {
  return <MLDashboardWidget cell={cell} dataField="assigned" />;
};

function insightsFormatter(cell, row) {
  if (!cell) return;
  function getRisk(risk_status) {
    switch (risk_status) {
      case 'h':
        return 'dotRed';
      case 'm':
        return 'dotYellow';
      case 'l':
        return 'dotGreen';
      default:
        return 'dotYellow';
    }
  }

  const riskMapping = (risk) => {
    const riskMap = {
      h: 'High',
      m: 'Moderate',
      l: 'Low',
    };

    return riskMap[risk] || risk; // fallback to original risk value if mapping doesn't exist
  };

  const typeMapping = (type) => {
    const typeMap = {
      MA2: 'PBS',
      AA2: 'MBS',
    };

    return typeMap[type] || type; // fallback to original type value if mapping doesn't exist
  };

  return (
    <div className={'flexHorizCentered'} key={uKey++}>
      <Fragment key={uKey++}>
        {cell.highriskInsight && cell.highriskInsight.risk_status === 'h' && (
          <div className={'offset-1 col-5'}>
            <button
              className={getRisk(cell.highriskInsight.risk_status)}
              data-tip
              data-for={'mbsHeaderTip-' + uKey}
            >
              {cell.highriskInsightNumber}
            </button>
            <ReactTooltip id={'mbsHeaderTip-' + uKey}>
              {cell.summary.map(([type, risk], index) => (
                <span key={index}>
                  {typeMapping(type)} - {riskMapping(risk)}
                  <br />
                </span>
              ))}
            </ReactTooltip>
          </div>
        )}
        {!cell.highriskInsight && <div className="cell-placeholder"></div>}
        {cell.mediumriskInsight &&
          cell.mediumriskInsight.risk_status === 'm' && (
            <div className={'offset-1 col-5'}>
              <div
                className={`${getRisk(cell.mediumriskInsight.risk_status)} , `}
                data-tip
                data-for={'pbsHeaderTip-' + uKey}
              >
                {cell.mediumriskInsightNumber}
              </div>
              <ReactTooltip id={'pbsHeaderTip-' + uKey}>
                {cell.summary.map(([type, risk], index) => (
                  <span key={index}>
                    {typeMapping(type)} - {riskMapping(risk)}
                    <br />
                  </span>
                ))}
              </ReactTooltip>
            </div>
          )}
      </Fragment>
    </div>
  );
}

function bulletListFormatter(cell) {
  if (cell) {
    return cell.split('/').map((e) => <li>{e.trim()}</li>);
  }
}

function episodeFormatter(cell) {
  if (cell) {
    return cell.split(', ').map((e) => (
      <li>
        <span
          className={!e.trim().toLowerCase().includes('open') ? 'episode' : ''}
        >
          {e.trim()}
        </span>
      </li>
    ));
  }
}

function bulletListCommaFormatter(cell) {
  if (cell) {
    return cell.split(', ').map((e) => <li>{e.trim()}</li>);
  }
}

const rowClasses = (row, rowIndex) => {
  if (row.closed) {
    return 'closedRow';
  } else if (row.isNewMessage) {
    return 'newMessageRow';
  } else if (row.assigned) {
    return 'highlighted-row';
  }
  return null;
};

export {
  namesFormatter,
  notesFormatter,
  imageFormatter,
  medsFormatter,
  syncFormatter,
  syncHeaderFormatter,
  mhrHeaderFormatter,
  commHeaderFormatter,
  insightsFormatter,
  bulletListFormatter,
  rowClasses,
  assignFormatter,
  mlWidgetFormatter,
  bulletListCommaFormatter,
  standardHeaderFormatter,
  insightsHeaderFormatter,
  episodeFormatter,
};
